module.exports = __webpack_public_path__ + "assets/img/button-gray.8e6363c3.png";